import React from "react";
import { useState } from "react";
import "../style/header.css";
import { NavLink, Link } from "react-router-dom";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { SiGmail } from "react-icons/si";

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <div
      className={`header ${menuOpen ? "menu-open" : ""}`}
      style={{ backgroundColor: "white", color: "#343D8A" }}
    >
      {/* Logo */}
      <div className="logo">
        <Link to="/" onClick={closeMenu}>
          <img src="K i m.png" alt="Logo" className="logo-image" />
        </Link>
      </div>

      <button
        type="button"
        className={`hamburger ${menuOpen ? "open" : ""}`}
        aria-label="Toggle navigation menu"
        aria-expanded={menuOpen}
        aria-controls="main-nav"
        onClick={() => setMenuOpen((open) => !open)}
      >
        <span className="hamburger-line" />
        <span className="hamburger-line" />
        <span className="hamburger-line" />
      </button>

      {/* Nav-menu */}
      <div className={`nav-menu ${menuOpen ? "open" : ""}`}>
        <nav className="nav" id="main-nav">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
            onClick={closeMenu}
          >
            Home
          </NavLink>

          <NavLink
            to="/projects"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
            onClick={closeMenu}
          >
            Technical Projects
          </NavLink>

          <NavLink
            to="/design-prototypes"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
            onClick={closeMenu}
          >
            Design Projects
          </NavLink>

          <NavLink
            to="/resume"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
            onClick={closeMenu}
          >
            My Resume
          </NavLink>

          <NavLink
            to="/about_me"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
            onClick={closeMenu}
          >
            About Me
          </NavLink>
        </nav>
      </div>

      {/* Contact icons */}
      <div className="contact-icons">
        <a
          href="https://github.com/KimNG02"
          target="_blank"
          rel="noopener noreferrer"
          className="github-link"
          aria-label="Visit my GitHub profile"
        >
          <span className="github-visit-bubble" aria-hidden="true">
            Visit me
          </span>
          <FaGithub className="github-icon" />
        </a>
        <a href="mailto:kimmine03@gmail.com">
          <SiGmail className="mail-icon" />
        </a>
        <a
          href="https://www.linkedin.com/in/kim-nguyen-287473215/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaLinkedin className="linkedin-icon" />
        </a>
      </div>
    </div>
  );
}
